<!--
 * @Descripttion:
 * @version:
 * @Author: lubaicen
 * @Date: 2020-09-10 14:20:04
 * @LastEditors: lubaicen
 * @LastEditTime: 2020-10-19 15:56:09
-->
<template>
  <ux-form
    class="bind-api x-padding-x"
    ref="form"
    :data="formData"
    :rules="rules"
    label-width="80px"
    data-automation="bindApi"
    :colon="true"
    @close="close"
    @confirm="confirm"
  >
    <my-form-item :label="$t('HT.apiStepOne.name')" prop="id">
      <ux-select
        v-model="formData.id"
        :options="apiList"
        :props="{ label: 'name', value: 'id' }"
      ></ux-select>
    </my-form-item>
    <my-form-item :label="$t('HT.addAccessApi.evn')" prop="env">
      <ux-select v-model="formData.env" :options="$opt.env2"></ux-select>
    </my-form-item>
  </ux-form>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      formData: {
        control: this.data.id, // 流量控制id
        id: '', // api-id
        env: '' // 环境
      },
      rules: {},
      apiList: []
    };
  },

  created() {
    this.getList();
  },

  methods: {
    /**
     * 获取列表
     * @param {Object} params 请求参数
     */
    getList(params) {
      this.$uxLoading.show();
      this.$api.api.getList(params).then((res) => {
        if (res.code == 10000) {
          this.apiList = res.data;
        }
      });
    },

    /**
     * 取消回调
     */
    close() {
      this.$uxModal.hide();
      this.$emit('close');
    },

    /**
     * 确认回调
     */
    confirm() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.$emit('confirm', this.formData);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
